import React, { useEffect, useState } from "react";

export const CATEGORY_COLORS = {
  Sneakers: "#7C98FF",
  Alternative: "#00E98E",
  Ticket: "#FFB547",
  TCG: "#FF577B",
  Internal: "#848484",
};

export const toHex = (n) => `#${Number(n || 0).toString(16).padStart(6, "0")}`;
export const fromHex = (h) => parseInt(String(h).replace("#", ""), 16) || 0;

export const flag = (code) => {
  if (!code || code.length !== 2) return code === "INT" ? "\u{1F310}" : "";
  return String.fromCodePoint(...code.toUpperCase().split("").map((c) => 127397 + c.charCodeAt(0)));
};

export const ClientAvatar = ({ src, name, color, size = 32 }) => {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [src]);
  if (src && !broken) {
    return (
      <img src={src} alt="" className="client-avatar" style={{ width: size, height: size }} onError={() => setBroken(true)} />
    );
  }
  return (
    <span
      className="client-avatar client-avatar-fallback"
      style={{ width: size, height: size, background: color ? toHex(color) : "#848484" }}
    >
      {(name || "?").trim().charAt(0).toUpperCase()}
    </span>
  );
};

export const AccessPill = ({ category, children }) => (
  <span className="access-pill">
    {category && <span className="access-dot" style={{ background: CATEGORY_COLORS[category] || "#848484" }} />}
    {children || category}
  </span>
);
